import { TLocale } from '@internal/utils/machine/i18n/Locale';
import { Machine } from '@internal/utils/machine/Machine';
import { FittedImage } from '@renderer-ui-library/atoms';
import { ThumbnailSlider } from '@renderer-ui-library/molecules';
import { ImageRatio } from '@renderer-ui-library/mui/utils/media/ImageRatio';
import React, { useMemo } from 'react';
import { MachinePlaceholderImageMapper } from 'utils/machine/placeholder/MachinePlaceholderImageMapper';
import { useMachineTypeName } from 'utils/machine/useMachineTypeName';

interface Props {
    machine: Machine;
    locale: TLocale;
}

export const MachinePreviewImage: React.FC<Props> = React.memo(
    ({ machine, locale }) => {
        const { getMachineTypeName } = useMachineTypeName();

        const previewImages = useMemo(
            () => (machine?.previewImage ? [machine?.previewImage] : []),
            [machine?.previewImage],
        );

        if (!machine) {
            return null;
        }

        if (previewImages) {
            return (
                <ThumbnailSlider
                    imageRatio={ImageRatio.Square}
                    media={previewImages}
                    pagination={false}
                    machine={machine}
                    locale={locale}
                    hideShareButton
                />
            );
        }

        return (
            <FittedImage
                ratio={ImageRatio.Square}
                src={
                    MachinePlaceholderImageMapper(machine.machineType, 'icon')
                        .url
                }
                alt={getMachineTypeName(machine.machineType, 'singular')}
            />
        );
    },
);

MachinePreviewImage.displayName = 'MachinePreviewImage';
